const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaTipo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PRODUTO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'PRODUTO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'PRODUTO_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

		case 'PRODUTO_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaTipo: action.payload.data
			};

        default:
            return state;
    }
}
